import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { navigateToSearchByTireSizes } from 'actions/shopByTires'
import YMMEControl from './YMMEControl'

export default compose(
  withType({ type: 'YMMEControll' }),
  connect(null, { handleShopByTireSizesSubmit: navigateToSearchByTireSizes })
)(YMMEControl)
